module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-first-screen-banner/assets/modal-bg.2fb7c5b185c3963f705f178e496d81a4.webp";